import React from 'react'

import {
    BackButton, Conditions, DetailHeader, DetailRoot, DetailTitle, ExternalLink,
    Fact, FactLabel, FactValue, Facts, Metric, Metrics, Section, SectionTitle,
    SourceBadge,
} from './styled'

export default function ResearchDetail({ formatCount, formatDate, onBack, onOpenSource, record, t }) {
    return (
        <DetailRoot>
            <BackButton type="button" onClick={onBack}>← {t('competitive_intelligence_nav_research')}</BackButton>
            <DetailHeader>
                <SourceBadge>{record.sourceLabel}</SourceBadge>
                <DetailTitle>{record.title}</DetailTitle>
            </DetailHeader>

            <Facts>
                <Fact>
                    <FactLabel>{t(`competitive_intelligence_activity_${record.activityKind}`)}</FactLabel>
                    <FactValue>{formatDate(record.activityDate)}</FactValue>
                </Fact>
                <Fact>
                    <FactLabel>{t('competitive_intelligence_research_identifier')}</FactLabel>
                    <FactValue>{record.externalIdentifier}</FactValue>
                </Fact>
                <Fact>
                    <FactLabel>{t('competitive_intelligence_research_collected')}</FactLabel>
                    <FactValue>{formatDate(record.collectedAt, true)}</FactValue>
                </Fact>
                {record.status ? (
                    <Fact><FactLabel>{t('competitive_intelligence_research_status')}</FactLabel><FactValue>{record.status.replace(/_/g, ' ')}</FactValue></Fact>
                ) : null}
            </Facts>

            {record.contributors || record.competitor || record.conditions?.length ? (
                <Section>
                    <SectionTitle>{t('competitive_intelligence_research_context')}</SectionTitle>
                    {record.contributors ? <Fact><FactLabel>{t('competitive_intelligence_research_contributors')}</FactLabel><FactValue>{record.contributors}</FactValue></Fact> : null}
                    {record.competitor ? <Fact><FactLabel>{t('competitive_intelligence_research_competitor')}</FactLabel><FactValue>{record.competitor}</FactValue></Fact> : null}
                    {record.conditions?.length ? <Fact><FactLabel>{t('competitive_intelligence_research_conditions')}</FactLabel><Conditions>{record.conditions.join(' · ')}</Conditions></Fact> : null}
                </Section>
            ) : null}

            {record.source === 'pubmed' ? (
                <Section>
                    <SectionTitle>{t('competitive_intelligence_research_publication')}</SectionTitle>
                    {record.details?.journal ? <Fact><FactLabel>{t('competitive_intelligence_research_journal')}</FactLabel><FactValue>{record.details.journal}</FactValue></Fact> : null}
                    {record.details?.sourcePublicationDate ? <Fact><FactLabel>{t('competitive_intelligence_research_source_date')}</FactLabel><FactValue>{record.details.sourcePublicationDate}</FactValue></Fact> : null}
                    {record.details?.citationCount != null || record.details?.relativeCitationRatio != null ? (
                        <Metrics>
                            {record.details?.citationCount != null ? <Metric><strong>{formatCount(record.details.citationCount)}</strong><span>{t('competitive_intelligence_research_citations')}</span></Metric> : null}
                            {record.details?.relativeCitationRatio != null ? <Metric><strong>{record.details.relativeCitationRatio}</strong><span>{t('competitive_intelligence_research_rcr')}</span></Metric> : null}
                        </Metrics>
                    ) : null}
                </Section>
            ) : null}

            {record.source === 'clinical-trials' && record.details?.firstSubmittedAt ? (
                <Section>
                    <SectionTitle>{t('competitive_intelligence_research_trial')}</SectionTitle>
                    <Fact><FactLabel>{t('competitive_intelligence_research_first_submitted')}</FactLabel><FactValue>{formatDate(record.details.firstSubmittedAt)}</FactValue></Fact>
                </Section>
            ) : null}

            {record.source === 'fda' ? (
                <Section>
                    <SectionTitle>{t('competitive_intelligence_research_regulatory')}</SectionTitle>
                    {[
                        ['deviceName', 'competitive_intelligence_research_device'],
                        ['applicant', 'competitive_intelligence_research_applicant'],
                        ['productCode', 'competitive_intelligence_research_product_code'],
                        ['clearanceType', 'competitive_intelligence_research_clearance_type'],
                        ['decisionDescription', 'competitive_intelligence_research_decision'],
                    ].map(([key, label]) => record.details?.[key] ? <Fact key={key}><FactLabel>{t(label)}</FactLabel><FactValue>{record.details[key]}</FactValue></Fact> : null)}
                    {record.details?.summaryPdfUrl ? <ExternalLink href={record.details.summaryPdfUrl} target="_blank" rel="noopener noreferrer" onClick={onOpenSource}>{t('competitive_intelligence_research_view_fda_summary')} ↗</ExternalLink> : null}
                </Section>
            ) : null}

            {record.externalUrl ? (
                <Section>
                    <SectionTitle>{t('competitive_intelligence_research_original_source')}</SectionTitle>
                    <ExternalLink href={record.externalUrl} target="_blank" rel="noopener noreferrer" onClick={onOpenSource}>
                        {t('competitive_intelligence_research_view_source')} ↗
                    </ExternalLink>
                </Section>
            ) : null}
        </DetailRoot>
    )
}
